export default __webpack_public_path__ + "static/media/avatarA2.42df47d3.png";